import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { Box, Typography, IconButton } from "@mui/material";
import KeyboardArrowLeft from "../../components/icon-components/KeyboardArrowLeft";
import { PAGE_HEADER_ADD_ADMIN, PLACEHOLDER_ROLE } from "../../utility/constants/locale";
import CustomDropdown from "../../components/custom-dropdown/CustomDropdown";
import CustomTextField from "../../components/custom-text-field/CustomTextField";
import CustomButton from "../../components/custom-button/CustomButton";
import CustomSpinner from "../../components/custom-spinner/CustomSpinner";
import {
  BTN_CANCEL,
  FORM_LABEL_ADMIN_ROLE,
  FORM_LABEL_ADMIN_NAME,
  FORM_LABEL_ADMIN_EMAIL_ID,
} from "../../utility/constants/locale";

import SearchComponent from "../../components/search-component/SearchComponent";

import "./AddAdmin.scss";
import { useSnackbar } from "notistack";
import { useAddAdminUserMutation } from "./PostAdminUserAPISlice";
import { useAppSelector } from "../../store/hooks";

const AddAdmin: React.FC = () => {
  const userName = useAppSelector((state) => state.adminAuth.user?.name);
  const userRoles = useAppSelector((state) => state.adminMasterData.userRoles);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [givenName, setGivenName] = useState("");
  const [surName, setSurName] = useState("");
  const [mail, setMail] = useState("");
  const [roleId, setRoleId] = useState(0);
  const [createdBy, setCreatedBy] = useState(userName || "SYSTEM");
  const [roleName, setRoleName] = useState("");
  const [isAdd, setIsAdd] = useState(false);
  const [roleIdNumber, setRoleIdNumber] = useState(0);
  const [roleDesc, setRoleDesc] = useState(" ");

  const handleDropDownChange = (value: string | number) => {
    setRoleId(value as number);
    setRoleIdNumber(value as number);
    const roleNameSelected = userRoles.find(
      (role) => role.value === (value as number)
    );
    setRoleName(roleNameSelected?.label || "");
    setRoleDesc(roleNameSelected?.desc || " ");
  };

  const handleInputChange = () => {};

  const navigateBack = () => {
    navigate(-1);
  };

  const accessToken = useAppSelector(
    (state) => state.adminAuth.user?.accessToken
  );
  const [addAdmin, { isLoading, isSuccess, isError, error }] =
    useAddAdminUserMutation();

  const SaveAddUser = async (values: any) => {
    if (roleIdNumber > 0) {
      try {
        setIsAdd(true);
        const body = {
          displayName: displayName,
          givenName: givenName,
          surName: surName,
          mail: mail,
          roleId: roleId,
          createdBy: createdBy,
          roleName: roleName,
        };

        // Call the mutation function
        const response = await addAdmin({ body, accessToken }).unwrap();
        enqueueSnackbar(
          `Admin user - “ ` +
            response?.adminUser?.emailId +
            `"added successfully`,
          {
            variant: "success",
          }
        );

        navigate("/admin");
      } catch (err: any) {
        if (err.status === 409) {
          console.error("Conflict: Duplicate entry detected.");
          enqueueSnackbar("User already exists", {
            variant: "success",
          }); //
        } else {
          console.error("Failed to add user: ", err);
          enqueueSnackbar("Failed to add User ", { variant: "error" });
        }
      } finally {
        setIsAdd(false);
      }
    } else {
      enqueueSnackbar("Select  UserName, Email Id & Role ", {
        variant: "warning",
      });
    }
  };

  const handleSelection = (
    selectedId: string,
    selectedName: string,
    givenName: string,
    surName: string
  ) => {
    // Set selected ID , Name, givenName & surName
    setMail(selectedName);
    setDisplayName(selectedId);
    setGivenName(givenName);
    setSurName(surName);
  };

  return (
    <Box p={3}>
      <Box display="flex" alignItems="center" mb={2} mt={2}>
        <IconButton onClick={() => navigate(-1)} aria-label="back button">
          <KeyboardArrowLeft />
        </IconButton>
        <Typography variant="h2">{PAGE_HEADER_ADD_ADMIN}</Typography>
      </Box>
      <Box sx={{ paddingLeft: "60px", marginTop: "40px", width: "100%" }}>
        To add a new user, search for the user by user name or email ID, select
        the correct username and email ID, and press enter to populate the
        fields below.
      </Box>
      <Box
        sx={{
          marginLeft: "60px",
          marginRight: "60px",
          marginTop: "20px",
          marginBottom: "40px",
          paddingTop: "20px",
          paddingBottom: "20px",
          alignItems: "center",
          backgroundColor: "#F2F2F2",
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            paddingTop: "20px",
            paddingBottom: "50px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
          className="SearchComponentAddAdmin"
        >
          <Box
            sx={{
              paddingLeft: "0px",
              textAlign: "center",
              paddingBottom: "10px",
              fontSize: "14px",
            }}
          >
            Please enter a minimum of four characters to search
          </Box>
          <SearchComponent onSelection={handleSelection} />
        </Box>
      </Box>
      <Grid
        container
        spacing={6}
        mb={2}
        sx={{ paddingLeft: "60px", paddingRight: "60px" }}
      >
        <Grid size={4}>
          <CustomTextField
            inputFormTitle={FORM_LABEL_ADMIN_NAME}
            value={displayName}
            placeholder="User Name"
            changeTrigger={handleInputChange}
            isRequired={true}
          />
        </Grid>
        <Grid size={4}>
          <CustomTextField
            inputFormTitle={FORM_LABEL_ADMIN_EMAIL_ID}
            value={mail}
            placeholder="Email ID"
            changeTrigger={handleInputChange}
            isRequired={true}
          />
        </Grid>

        <Grid size={4}>
          <CustomDropdown
            inputFormTitle={FORM_LABEL_ADMIN_ROLE}
            value={roleId}
            changeTrigger={(value) => handleDropDownChange(value)}
            options={userRoles}
            isRequired
            placeholder={PLACEHOLDER_ROLE}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        mb={2}
        sx={{ paddingLeft: "60px", paddingRight: "60px", marginTop: "40px" }}
      >
        <CustomButton
          variant="outlined"
          onClick={navigateBack}
          text={BTN_CANCEL}
        />
        <CustomButton
          type="submit"
          variant="contained"
          color="primary"
          onClick={SaveAddUser}
          text={PAGE_HEADER_ADD_ADMIN}
        />

        {isAdd && <CustomSpinner />}
      </Grid>
      {roleName === "Select Role" ? (
        ""
      ) : (
        <Grid
          container
          spacing={1}
          sx={{ paddingLeft: "60px", paddingRight: "60px" }}
        >
          <Grid size={12} sx={{ display: "flex", justifyContent: "left" }}>
            <Typography sx={{ fontWeight: "600", paddingRight: "10px" }}>
              {roleName}
            </Typography>
            <Typography>{roleDesc}</Typography>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default AddAdmin;
